<template>
  <div class="account-row change-password">
    <div class="heading">
      <h2>{{$ml.get(`Change Password`)}}</h2>
      <app-btn
        @click="save"
      >{{ $ml.get(`save`) }}</app-btn>
    </div>
    <form>
      <app-text-input
        :label="$ml.get(`Old Password`)"
        type="password"
        v-model="data.oldPass"
        v-if="user.isPasswordSet"
      />
      <app-text-input
        :label="$ml.get(`New Password`)"
        type="password"
        v-model="data.newPass"
      />
      <app-text-input
        :label="$ml.get(`Confirm Password`)"
        type="password"
        v-model="data.confirmNewPass"
      />
    </form>



  </div>
</template>

<script>
import API from '@/api'
import { mapGetters } from 'vuex';
export default {
  props: {
    data : {
      required: true
    }
  },
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters({
      user: 'user/data'
    })
  },
  methods : {
    save() {

      let request = {
        oldPassword : this.data.oldPass,
        newPassword : this.data.newPass,
        confirmPassword : this.data.confirmNewPass,
      };

      if(this.user.isFilledPassword && !request.oldPassword) {
        this.$notify({
          group: 'notices',
          title: this.$ml.get(`Enter your old password`),
          type : 'error',
        });
        return;
      }

      if(request.newPassword === request.confirmPassword) {
        if(request.newPassword.length < 6) {
          this.$notify({
            group: 'notices',
            title: this.$ml.get(`Minimum password length is 6 characters`),
            type : 'error',
          });
        } else {
          return API.user.updatePassword(request).then(res => {
            this.$notify({
              group: 'notices',
              title: this.$ml.get(`Your data was successfully updated!`),
              type : 'success',
            });

            this.$store.dispatch('user/updateData');
          }).catch(err => {
            this.$notify({
              group: 'notices',
              title: `Error! "${err.response.data.err}"`,
              type : 'error',
            });
          });
        }
      } else {
        this.$notify({
          group: 'notices',
          title: this.$ml.get(`Error in Confirm Password`),
          type : 'error',
        });
      }

    }
  },
}
</script>

<style lang="scss" scoped>

</style>
